import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { connect } from "react-redux";
import * as galleryActions from "../../actions/gallery";
import {withRouter} from 'react-router';

import NewItem from '../common/NewItem';
import GraphicItem from './GraphicItem';
import FilterBar from "../common/FilterBar";
import Slider from "../includes/Slider/index";
import Loader from 'react-loader-spinner';

import AuthService from '../../lib/AuthService';
import GraphicModal from "./GraphicModal";


class GraphicsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            imagesList :[],
            modal: false,
            iname_class : '',
            itags_class : '',
            image_name: '',
            image_tags: '',
            image_path: '',
            redirect: false,
            loader : true,
            showModal : false
        };
        this.Auth = new AuthService();
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

    }

    componentWillMount() {

    }


    componentDidMount() {

        if(!this.props.source || this.props.source !== 'vignets' ) {
            let data = {"gal_type" : this.props.galleryInfo.gal_type, userid : this.Auth.getProfile().user_id,size:50,offset:0};
            this.props.allGalleryData(data);
        }


        let wrap_class = 'gallery-main-wrap';

        if(this.props.source && this.props.source === 'vignets' ) {
            wrap_class += ' video-float audio-player ';
        } else{
            switch(this.props.galleryInfo.gal_type) {
                case 'MY_UPLOADS' : wrap_class += ' image-float ';
                    break;

                case 'AUDIO' : wrap_class += ' voice-float audio-player';
                    break;
                case 'VIDEO' : wrap_class += ' video-float audio-player ';
                    break;
                default : wrap_class += ' image-float';
                    break;
            }
        }

        this.setState({ wrap_class : wrap_class });

        const container = document.querySelector('.right-bottom-area');
        container.addEventListener('scroll', this.listenToScroll)
    }

    componentWillUnmount() {
        const container = document.querySelector('.right-bottom-area');
        container.removeEventListener('scroll', this.listenToScroll)
    }

    listenToScroll = () => {
        const container = document.querySelector('.right-bottom-area')
        let lastOffset = document.querySelector('.gallery-main-wrap').childElementCount-1;
        var scrollTop = container.scrollTop;
        var scrollHeight = container.scrollHeight;
        var offsetHeight = container.offsetHeight;
        var contentHeight = scrollHeight - offsetHeight;

        // console.log(scrollTop+"----"+scrollHeight+"----"+offsetHeight+"-----"+contentHeight);

        if (contentHeight <= scrollTop) {
            let plId = "";
            let data = {"gal_type" : this.props.galleryInfo.gal_type, userid : this.Auth.getProfile().user_id,size:50,offset:lastOffset};
            this.props.moregalleryData(data);
        }

    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.galleryData.galleryItems !== prevProps.galleryData.galleryItems &&  this.props.galleryData.galleryItems) {
            this.setState({loader : false})
        }
        if (this.props.vignetsGallery !== prevProps.vignetsGallery) {
            this.setState({loader : false})
        }

        if (this.props.galleryInfo.galleryCreated !== prevProps.galleryInfo.galleryCreated ) {
            this.forceUpdateHandler();
        }
        if(this.props.galleryInfo.deleted  !== prevProps.galleryInfo.deleted ) {
            let data = {"gal_type" : this.props.galleryInfo.gal_type, userid : this.Auth.getProfile().user_id,size:50,offset:0};
            this.props.allGalleryData(data);
        }
    }
    showModal() {
        this.setState({showModal : true});
    }
    closeModal() {
        this.setState({showModal : false});
    }

    forceUpdateHandler(){
        let data = {"gal_type" : this.props.galleryInfo.gal_type, userid : this.Auth.getProfile().user_id,size:50,offset:0};
        this.props.allGalleryData(data);
    }

    renderSlider(galList) {

        /*return (
            <div>
            { galList &&
            <Slider galItems={galList}/>
            }
            </div>
        );*/
    }

    render() {
    	const { redirect } = this.state;

        if (redirect) {
            return <Redirect to='/builder'/>;
        }

        let galleryListdetail = (this.props.galleryData.searchText || this.props.galleryData.sort) ? this.props.galleryData.filteredData :  this.props.galleryData.galleryItems;
        let galleryList=this.props.vignetsGallery ? this.props.vignetsGallery : galleryListdetail;

        return (

            <div className={this.props.galleryInfo.viewMode === "list" ? this.state.wrap_class+' list-view' : this.state.wrap_class } >

                {this.state.loader &&
                <div className="loaderWrapper">
                    <Loader type="ThreeDots" color="#54a1d7"  height="50" width="50"/>
                </div>
                }
                {this.props.source !== 'vignets' &&
                <NewItem item_type={this.props.galleryInfo.gal_type}/>
                }

                {this.props.galleryInfo.viewMode === "list" &&
                <div className="glery-main head">
                    <div className="head-name">
                        <h5>Name</h5>
                    </div>
                    <div className="other-contents">
                        <div className="ind-tb gal-size">
                            <h5>Size</h5>
                        </div>
                        <div className="ind-tb gal-user">
                            <h5>Uploaded By</h5>
                        </div>
                        <div className="ind-tb gal-date">
                            <h5>Date</h5>
                        </div>
                        <div className="ind-tb gal-date">
                            <h5 className="action-right">Action</h5>
                        </div>
                    </div>
                </div>
                }

                {!this.state.loader && galleryList  &&
                    galleryList.filter(list=>list.img_id !== "yt").map((entry, index) =>
                            <GraphicItem detail={entry} galIndex={index} showModal={this.showModal} source={this.props.source} vgtyp={this.props.vgtyp}/>

                        )
                }
                { this.props.galleryInfo.gal_type !== 'AUDIO' ? this.renderSlider(galleryList):null }
                {this.state.showModal &&

                   <Slider galItems={galleryList} closeModal={this.closeModal} source={this.props.source} vgtyp={this.props.vgtyp}/>
                }
            </div>


        );
    }
}


GraphicsContainer.propTypes = {
    gal_type: PropTypes.string
}


function mapStateToProps(state) {
    return {
        galleryData  :state.gallery.galleryData,
        galleryInfo  :state.gallery.galleryUpdate,
    };

}
export default  withRouter(connect(mapStateToProps, {
    allGalleryData : galleryActions.galleryData,
    moregalleryData : galleryActions.moregalleryData
})(GraphicsContainer, FilterBar));




// WEBPACK FOOTER //
// ./src/components/gallery/GraphicsContainer.js